export default "__VITE_ASSET__CnHLwrEi__"